import { render, staticRenderFns } from "./ParametersManagement.vue?vue&type=template&id=b93250c8&scoped=true&"
import script from "./ParametersManagement.vue?vue&type=script&lang=js&"
export * from "./ParametersManagement.vue?vue&type=script&lang=js&"
import style0 from "./ParametersManagement.vue?vue&type=style&index=0&id=b93250c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93250c8",
  null
  
)

export default component.exports